import { NavigationEnd } from "@angular/router";
import { Component, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "src/app/shared/service/login.service";
import { LoadingState } from "../loading/loading-state";
import { CommonService } from "../../service/common.service";
import { SESSION_KEY } from "../../constant/session-constants";
import { CONSTANT, MATCH_TYPE, NO_LOGIN_SCREENS, ROLES } from "src/app/shared/constant/constant";
import { MESSAGE_CODE } from "src/app/shared/constant/message-constant";
import { MenuItem } from "primeng/api";
import { NotificationDialogComponent } from "src/app/shared/html-parts/notification-dialog/notification-dialog.component";
import { DbOperationService } from "../../service/db-operation.service";
import { COUNT_UNREAD } from "manager/http-constants";
import { title } from "process";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})

/**
 * ヘッダー
 */
export class HeaderComponent implements OnInit, OnDestroy {
  // ヘッダー判定フラグ(true:通常モード、false:メッセージモード)
  @Input() headerFlag: boolean;

  @ViewChild(NotificationDialogComponent)
  NotificationDialogComponent: NotificationDialogComponent;

  // 文字サイズ選択項目
  textSizeList: Object[] = [
    {
      name: "標準",
      code: "false",
    },
    {
      name: "拡大",
      code: "true",
    },
  ];

  guestMobileHeaderMenu: Object[] = [
    {
      title: "ウェブアクセシビリティ",
      action: (event) => {
        this.redirectTo('pages/platform/accessibility');
        this.closeMobileMenu();
      }
    },
    // {
    //   title: "団体一覧",
    //   action: (event) => {
    //     this.redirectTo('pages/platform/a110');
    //     this.closeMobileMenu();
    //   }
    // },
    {
      title: "連携事例一覧",
      action: (event) => {
        this.moves('pages/platform/c261/');
        this.closeMobileMenu();
      }
    },
    {
      title: "よくある質問集",
      action: (event) => {
        this.getQA();
        this.closeMobileMenu();
      }
    }
  ];

  guestDesktopHeaderMenu: Object[] = [
    {
      title: "ウェブアクセシビリティ",
      id: "gdhm1",
      action: (id) => {
        this.blurElementById(id);
        this.redirectTo('pages/platform/accessibility');
      }
    },
    // {
    //   title: "団体一覧",
    //   id: "gdhm2",
    //   action: (id) => {
    //     this.blurElementById(id);
    //     this.redirectTo('pages/platform/a110');
    //   }
    // },
    {
      title: "連携事例一覧",
      id: "gdhm3",
      action: (id) => {
        this.blurElementById(id);
        this.moves('pages/platform/c261/');
      }
    },
    {
      title: "よくある質問集",
      id: "gdhm4",
      action: (id) => {
        this.blurElementById(id);
        this.getQA();
      }
    },
    {
      title: "利用登録",
      id: "gdhm4",
      action: (id) => {
        this.blurElementById(id);
        this.redirectTo('pages/platform/a201', { screenId: 'a201' });
      }
    },
    {
      title: "ログイン",
      id: "gdhm5",
      action: (id) => {
        this.blurElementById(id);
        this.login();
      }
    },
  ];

  // 文字サイズ
  textSize: string;
  // 課題ID
  agendaId: any;

  id: any;

  cities: any[] = [
    { name: "プロフィール", code: "Profile" },
    { name: "お問い合わせ", code: "Contact" },
    { name: "ログアウト", code: "Logout" },
  ];

  intervalUnread: NodeJS.Timeout;
  role: any[] = [{ name: "Teacher", code: "1" }];
  selectedCity: any;
  menuList: any[] = [];
  indexMenuActive = -1;
  class_id: any;
  lengthMenu: any;
  items: Object[] = [];
  activeItem2: any;
  member_id: any;
  unread_notification: number = 0;
  user: any = null;
  isOpenMoblieMenu: boolean[] = [false, false];

  constructor(
    private router: Router,
    private commonService: CommonService,
    private loginService: LoginService,
    private loadingState: LoadingState,
    public dbOperationService: DbOperationService,
    private route: ActivatedRoute
  ) { }
  ngOnDestroy(): void {
    clearInterval(this.intervalUnread);
  }

  ngOnInit() {
    // this.getCount();
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.id = e.url;

        if (this.user) {
          this.loadingState.loadSleepEnd(0.3);
          this.class_id = this.user.class_id;
          this.member_id = this.user.member_id;
          this.updateDataDisplayMenu();
          this.updateRightMenu();
          this.getCount();
        } else {
          if (!this.loginService.getAuth0LoginState()) {
            return
          }
          for (let index = 0; index < NO_LOGIN_SCREENS.length; index++) {
            const element = NO_LOGIN_SCREENS[index];
            if (e.url.replace('/', '').startsWith(element)) {
              return;
            }
          }
          this.loginService.getLoginUser().subscribe((response) => {
            this.loadingState.loadSleepEnd(0.3);

            if (this.commonService.checkNoneResponse(response)) {
              this.loginService.logout(MESSAGE_CODE.E90000);
              return;
            } else {
              this.user = response.body;
              this.class_id = response.body.class_id;
              this.member_id = response.body.member_id;
              this.updateDataDisplayMenu();
              this.updateRightMenu();
              this.getCount();
            }
          });
        }
      }
    });
    // this.initUpdateBell();
  }

  // private initUpdateBell() {
  //   this.intervalUnread = setInterval(async () => {
  //     this.getCount();
  //   }, 5000);
  // }

  public updateRightMenu(): void {
    switch (this.class_id) {
      case ROLES.SCHOOL:
        this.items = [
          {
            label: "お知らせ一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/e001/1",
          },
          {
            label: "団体検索・一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/a110",
          },
          {
            label: "団体ユーザー一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/b220",
          },
          {
            label: "連携事例一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/c261",
          },
          {
            label: "団体プロフィール",
            icon: "pi pi-pencil",
            url: `/pages/platform/b211/${this.member_id}?back=0`,
          },
          { separator: true },
          {
            label: "ログアウト",
            icon: "pi pi-sign-out",
            command: (event) => {
              this.loginService.logout();
            },
            index: 5,
          },
        ];
        break;

      case ROLES.NURSERY:
        this.items = [
          {
            label: "お知らせ一覧",
            icon: "pi pi-user-edit",
            url: "/pages/platform/e001/1",
          },
          {
            label: "団体検索・一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/a110",
          },
          {
            label: "団体ユーザー一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/b220",
          },
          {
            label: "連携事例一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/c261",
          },
          {
            label: "団体プロフィール",
            icon: "pi pi-pencil",
            url: `/pages/platform/b211/${this.member_id}?back=0`,
          },

          { separator: true },
          {
            label: "ログアウト",
            icon: "pi pi-sign-out",
            command: (event) => {
              this.loginService.logout();
            },
          },
        ];
        break;

      case ROLES.PROVIDER_INDIVIDUAL:
        this.items = [
          {
            label: "お知らせ一覧",
            icon: "pi pi-user-edit",
            url: "/pages/platform/e001/1",
          },
          // {
          //   label: "イベントマスタ管理",
          //   icon: "pi pi-pencil",
          //   url: "/pages/platform/master/m601",
          // },
          {
            // label: "ニーズマスタ管理",
            // icon: "pi pi-pencil",
            // url: "/pages/platform/master/m301",
            label: "登録支援管理",
            icon: "pi pi-pencil",
            url: "/pages/platform/master/m301",
          },
          {
            label: "団体検索・一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/a110",
          },
          {
            label: "団体ユーザー一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/b220",
          },
          {
            label: "団体プロフィール",
            icon: "pi pi-pencil",
            url: `/pages/platform/b211/${this.member_id}?back=0`,
          },

          { separator: true },
          {
            label: "ログアウト",
            icon: "pi pi-sign-out",
            command: (event) => {
              this.loginService.logout();
            },
          },
        ];
        break;

      case ROLES.ADMIN:
        this.items = [
          {
            label: "マッチングメッセージ",
            icon: "pi pi-user-edit",
            url: "/pages/platform/c601",
          },
          {
            label: "中学校・高校等の希望一覧",
            icon: "pi pi-user-edit",
            url: "/pages/platform/c231",
          },
          {
            label: "保育所・幼稚園等の希望一覧",
            icon: "pi pi-user-edit",
            url: "pages/platform/c241",
          },
          {
            label: "お知らせ一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/e001/1",
          },
          {
            label: "連携事例一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/c261",
          },
          {
            label: "団体検索・一覧",
            icon: "pi pi-pencil",
            url: "/pages/platform/a110",
          },
          {
            label: "団体マスタ管理",
            icon: "pi pi-pencil",
            url: "/pages/platform/master/m101",
          },
          {
            label: "ユーザーマスタ管理",
            icon: "pi pi-pencil",
            url: "pages/platform/master/m201",
          },
          {
            label: "中学校・高校等希望管理",
            icon: "pi pi-pencil",
            url: "pages/platform/master/m301",
          },
          {
            label: "保育所・幼稚園等希望管理",
            icon: "pi pi-pencil",
            url: "pages/platform/master/m401",
          },
          {
            label: "お知らせマスタ管理",
            icon: "pi pi-pencil",
            url: "/pages/platform/master/m501",
          },
          {
            label: "団体プロフィール",
            icon: "pi pi-pencil",
            url: `/pages/platform/b211/${this.member_id}?back=0`,
          },
          { separator: true },
          {
            label: "ログアウト",
            icon: "pi pi-sign-out",
            command: (event) => {
              this.loginService.logout();
            },
          },
        ];
        break;
    }
  }

  public updateDataDisplayMenu(): void {
    switch (this.class_id) {
      case ROLES.SCHOOL: {
        this.menuList = [
          { title1: "マイページ", link: "/pages/platform/b301", index: 0 },
          {
            title1: "ふれあい体験希望",
            title2: "登録・管理",
            link: "/pages/platform/master/m301",
            index: 1,
          },
          {
            title1: "中学校・高校等の",
            title2: "希望一覧",
            link: "/pages/platform/c231",
            index: 2,
          },
          {
            title1: "保育所・幼稚園等",
            title2: "の希望一覧",
            link: "/pages/platform/c241",
            index: 3,
          },
          {
            title1: "マッチング一覧",
            link: "/pages/platform/c502",
            index: 4,
          },
          {
            title1: "メッセージ",
            link: "/pages/platform/c601",
            index: 5,
          },
        ];
        break;
      }

      case ROLES.NURSERY: {
        this.menuList = [
          { title1: "マイページ", link: "/pages/platform/b301", index: 0 },
          {
            title1: "ふれあい体験希望",
            title2: "登録・管理",
            link: "/pages/platform/master/m401",
            index: 1,
          },
          {
            title1: "中学校・高校等の",
            title2: "希望一覧",
            link: "/pages/platform/c231",
            index: 2,
          },
          {
            title1: "保育所・幼稚園等",
            title2: "の希望一覧",
            link: "/pages/platform/c241",
            index: 3,
          },
          {
            title1: "マッチング一覧",
            link: "/pages/platform/c502",
            index: 4,
          },
          {
            title1: "メッセージ",
            link: "/pages/platform/c601",
            index: 5,
          },
        ];
        break;
      }
      case ROLES.ADMIN: {
        this.menuList = [
          { title1: "トップページ", link: "/pages/platform/b301", index: 0 },
          {
            title1: "利用申請",
            title2: "検索・一覧",
            link: "/pages/platform/secretariat-list/d211",
            index: 1,
          },
          //master thảo luận
          {
            title1: "相談一覧",
            title2: "(マッチング後)",
            link: "/pages/platform/master/m701",
            index: 2,
          },
          {
            title1: "ユーザー",
            title2: "メッセージ",
            link: "/pages/platform/c602",
            index: 3,
          },
          {
            title1: "マッチング",
            title2: "一覧",
            link: "/pages/platform/c502",
            index: 4,
          },
          {
            title1: "連携事例",
            title2: "管理",
            link: "/pages/platform/master/m601",
            index: 5,
          }
        ];
        break;
      }
      default: { }
    }
  }


  public isActive(menuItem?: any): void | boolean {
    if (menuItem && this.router.url === menuItem?.link) {
      if (this.indexMenuActive >= 0) {
        document
          .querySelectorAll(".p-tabmenuitem")
        [this.indexMenuActive]?.classList.remove("white-background");
        document
          .querySelectorAll(".text-white-color")
        [this.indexMenuActive]?.classList.remove("text-red-color");


        this.indexMenuActive = -1;
      }

      document
        .querySelectorAll(".p-tabmenuitem")
      [menuItem.index].classList.add("white-background");
      document
        .querySelectorAll(".text-white-color")
      [menuItem.index].classList.add("text-red-color");
    } else {
      if (this.class_id === ROLES.SCHOOL) {
        if (
          this.router.url.startsWith("/pages/platform/master/m301")
        ) {
          this.indexMenuActive = 1;
        } else if (
          this.router.url.startsWith("/pages/platform/c331") ||
          this.router.url.startsWith("/pages/platform/c361")
        ) {
          this.indexMenuActive = 2;
        } else if (
          this.router.url.startsWith("/pages/platform/master/m401")
        ) {
          this.indexMenuActive = 1;
        } else if (
          this.router.url.startsWith("/pages/platform/c341") ||
          this.router.url.startsWith("/pages/platform/c401") ||
          this.router.url.startsWith("/pages/platform/c403")) {
          this.indexMenuActive = 3;
        }
        else if (
          this.router.url.startsWith("/pages/platform/c701") ||
          this.router.url.startsWith("/pages/platform/c703")
        ) {
          this.indexMenuActive = 4;
        } else if (this.router.url.startsWith("/pages/platform/c601")) {
          this.indexMenuActive = 5;
        } else {
          this.indexMenuActive = -1;
        }
      } else if (this.class_id === ROLES.ADMIN) {
        if (
          ((this.router.url.startsWith("/pages/platform/c401") ||
            this.router.url.startsWith("/pages/platform/c403")) &&
            this.router.url.endsWith(
              `match_type=${MATCH_TYPE.AGENDA_SOLUTION}`
            ))
        ) {
          this.indexMenuActive = 5;
        } else if (
          this.router.url.startsWith("/pages/platform/c361") ||
          this.router.url.startsWith("/pages/platform/c461") ||
          this.router.url.startsWith("/pages/platform/c462")
        ) {
          this.indexMenuActive = 4;
        } else if (
          ((this.router.url.startsWith("/pages/platform/c401") ||
            this.router.url.startsWith("/pages/platform/c403")) &&
            this.router.url.endsWith(`match_type=${MATCH_TYPE.AGENDA_NEED}`))
        ) {
          this.indexMenuActive = 6;
        } else if (
          this.router.url.startsWith("/pages/platform/c701") ||
          this.router.url.startsWith("/pages/platform/c703")
        ) {
          this.indexMenuActive = 3;
        } else if (this.router.url.startsWith("/pages/platform/c602")) {
          this.indexMenuActive = 3;
        } else {
          this.indexMenuActive = -1;
        }
      } else if (this.class_id === ROLES.NURSERY || this.class_id === ROLES.PROVIDER_INDIVIDUAL) {
        if (this.router.url.startsWith("/pages/platform/master/m301")) {
          this.indexMenuActive = 1;
        } else if (
          this.router.url.startsWith("/pages/platform/c361") ||
          this.router.url.startsWith("/pages/platform/c331")
        ) {
          this.indexMenuActive = 2;
        } else if (
          this.router.url.startsWith("/pages/platform/c341")
        ) {
          this.indexMenuActive = 3;
        } else if (
          this.router.url.startsWith("/pages/platform/c401") ||
          this.router.url.startsWith("/pages/platform/c403")
        ) {
          this.indexMenuActive = 2;
        } else if (
          this.router.url.startsWith("/pages/platform/c701") ||
          this.router.url.startsWith("/pages/platform/c703")
        ) {
          this.indexMenuActive = 4;
        } else if (this.router.url.startsWith("/pages/platform/c601")) {
          this.indexMenuActive = 5;
        } else {
          this.indexMenuActive = -1;
        }
      }

      document
        .querySelectorAll(".p-tabmenuitem")
      [this.indexMenuActive]?.classList.add("white-background");
      document
        .querySelectorAll(".text-white-color")
      [this.indexMenuActive]?.classList.add("text-red-color");
    }
  }

  public checkShowMenu(): boolean {
    if (
      this.id &&
      (this.id.startsWith("/pages/platform/a201") ||
        this.id.startsWith("/pages/platform/a203") ||
        this.id.startsWith("/pages/platform/a210") ||
        this.id.startsWith("/pages/platform/a211") ||
        this.id.startsWith("/pages/platform/a212") ||
        this.id.startsWith("/pages/platform/a213") ||
        this.id.startsWith("/pages/platform/a203") ||
        this.id.startsWith("/pages/platform/a204") ||
        this.id.startsWith("/pages/platform/landing") ||
        this.id.startsWith("/pages/platform/contact") ||
        this.id.startsWith("/pages/platform/privacy") ||
        this.id.startsWith("/pages/platform/accessibility") ||
        (this.id.startsWith("/pages/platform/c231") && !this.user) ||
        (this.id.startsWith("/pages/platform/c331") && !this.user) ||
        (this.id.startsWith("/pages/platform/c261") && !this.user) ||
        (this.id.startsWith("/pages/platform/c361") && !this.user) ||
        (this.id.startsWith("/pages/platform/e002") && !this.user) ||
        (this.id.startsWith("/pages/platform/a110") && !this.user)) ||
        this.id == "/" ||
        (this.id.startsWith("/pages/platform/e001") && !this.user)) {
      return false;
    }
    return true;
  }

  public checkShowIconButton(): boolean {
    if (
      this.id &&
      (this.id.startsWith("/pages/platform/a201") ||
        this.id.startsWith("/pages/platform/a203") ||
        this.id.startsWith("/pages/platform/a210") ||
        this.id.startsWith("/pages/platform/a211") ||
        this.id.startsWith("/pages/platform/a212") ||
        this.id.startsWith("/pages/platform/a213") ||
        this.id.startsWith("/pages/platform/a203") ||
        this.id.startsWith("/pages/platform/a204") ||
        this.id.startsWith("/pages/platform/landing") ||
        this.id.startsWith("/pages/platform/contact") ||
        this.id.startsWith("/pages/platform/privacy") ||
        this.id.startsWith("/pages/platform/accessibility") ||
        this.id == "/"
      )
    ) {
      return false;
    }
    return true;
  }

  public checkLanding(): boolean {
    if (
      this.id &&
      (this.id.startsWith("/pages/platform/landing") ||
        this.id.startsWith("/pages/platform/contact") ||
        this.id.startsWith("/pages/platform/privacy") ||
        this.id.startsWith("/pages/platform/accessibility") ||
        this.id == "/"
      )
    ) {
      return true;
    } else if (
      (this.id?.startsWith("/pages/platform/c231") ||
        this.id?.startsWith("/pages/platform/c331") ||
        this.id?.startsWith("/pages/platform/c261") ||
        this.id?.startsWith("/pages/platform/c361") ||
        this.id?.startsWith("/pages/platform/e001") ||
        this.id?.startsWith("/pages/platform/e002") ||
        this.id?.startsWith("/pages/platform/a110")) &&
      !this.user
    ) {
      return true;
    }
    return false;
  }

  public isA201() {
    return this.id?.startsWith("/pages/platform/a201") || this.id?.startsWith("/pages/platform/a203") || this.id?.startsWith("/pages/platform/a204")
  }

  public headerActive(): boolean {
    if (this.id && this.id.startsWith("/pages/platform/landing")) {
      return false;
    }
    return true;
  }
  openNotificationDialog(event: Event) {
    this.NotificationDialogComponent.openDialog(event);
  }
  login() {
    this.loginService.logout();
  }
  getCount() {
    this.dbOperationService
      .getNoTemplateData(COUNT_UNREAD, {}, false)
      .subscribe((response) => {
        if (!this.commonService.checkNoneResponse(response)) {
          this.unread_notification = response.body.count;
        } else {
          this.unread_notification = 0;
        }
      });
  }

  moves(path: string) {
    this.router.navigate([path]);
  }
  closeMobileMenu() {
    this.isOpenMoblieMenu[0] = false;
    this.isOpenMoblieMenu[1] = false;
  }
  redirectTo(path: string, param?: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true, }).then(() => this.router.navigate([path], { queryParams: param }));
  }
  blurElementById(id: string) {
    document.getElementById(id).blur();
  }

  getManualSchool() {
    window.open("")
  }

  getManualSupport() {
    window.open("")
  }
  getQA(){
    window.open("https://fukuoka-prod-file.s3.ap-northeast-1.amazonaws.com/common/pdf/%E3%82%88%E3%81%8F%E3%81%82%E3%82%8B%E8%B3%AA%E5%95%8F%E9%9B%86.pdf")
  }
  public isPage(path: string) {
    const re = this.id?.startsWith(path);
    return re
  }

  /**
   * ロゴクリック時のナビゲーション処理
   * 未ログインの場合：ランディングページへ遷移
   * ログイン済みの場合：マイページへ遷移
   */
  navigateToHome() {
    if (this.user) {
      // ログイン済みの場合はマイページへ
      this.router.navigate(['/pages/platform/b301']);
    } else {
      // 未ログインの場合はランディングページへ
      this.router.navigate(['/']);
    }
  }
}
